import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Form,
  Input,
  Select,
  Button,
  Steps,
  Card,
  Row,
  Col,
  Space,
  Typography,
  Divider,
  message,
  Checkbox,
  Tag,
  Switch,
  Modal,
  Tooltip
} from 'antd';
import {
  PlusOutlined,
  MinusOutlined,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  CreditCardOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import "./createNetwork.scss";
import IntlTelInput from "intl-tel-input/react";
import "intl-tel-input/styles";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import { useDispatch, useSelector } from 'react-redux';

import { addONUser, fetchONMemberShipPlans, fetchONRoles, fetchONSpecialities, registerMembership, resetFetchONRoles, resetFetchONSpecialities, fetchONUserDetails, resetFetchONUserDetails, editONRequest, createNetwork } from '../../../features/superAdmin/requestLIsts/requestListsSlice';
import { toast } from 'react-toastify';
import { appDispatch, RootState } from '../../../app/store';
import { makePayment, validateLogin } from '../../../features/members/membersSlice';
import { StorageService } from '../../../core/storageService/storageService';

const { Title, Text } = Typography;
const { Option } = Select;

interface LicenseInfo {
  country: string; // iso2
  countryId?: number; // id
  countryName?: string;
  state: string; // state_code
  stateId?: number; // id
  stateName?: string;
  licenseNumber: string;
}

interface ContactInfo {
  email: string;
  emailPreference: string;
  pager: string;
  pagerPreference: string;
  primaryPhone: string;
  primaryPhoneCode: string;
  primaryPhonePreference: string;
  secondaryPhone: string;
  secondaryPhoneCode: string;
  secondaryPhonePreference: string;
  practiceName: string;
  practicePosition: string;
  optionalPhone: string;
  optionalPhoneCode: string;
  country: string;
  state: string;
  city: string;
  address: string;
}

type PracticeDetail = {
  practiceName: string;
  practicePosition: string;
  optionalPhone: string;
  optionalPhoneCode: string;
  country: string;
  countryName: string;
  state: string;
  stateName: string;
  city: string;
  cityName: string;
  cityId?: string; // <-- Add cityId
  address: string;
  address2: string;
  zipcode: any;
};

export const CreateNetwork = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [licenses, setLicenses] = useState<LicenseInfo[]>([
    { country: '', countryId: undefined, state: '', stateId: undefined, licenseNumber: '' }

  ]);
  const [loadingPlanId, setLoadingPlanId] = useState<string | null>(null);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authUsername, setAuthUsername] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  const [authError, setAuthError] = useState('');

  const [form] = Form.useForm();

  const location = useLocation();

  const { isEditMode = false, userId = "" } = location?.state || {};

  const dispatch = useDispatch<appDispatch>();

  const {
    ONRolesListData,
    isLoading: isONRolesLoading
  } = useSelector((state: RootState) => state.requestLsts.fetchONRoles);

  const {
    ONSpecialitiesListData,
    isLoading: isONSpecialitiesLoading
  } = useSelector((state: RootState) => state.requestLsts.fetchONSpecialities);

  const {
    mombershipPlanListData,
    isLoading: isMembershipListLoading
  } = useSelector((state: RootState) => state.requestLsts.fetchONMemberShipPlans);
  console.log(mombershipPlanListData, "mombershipPlanListData")
  const {
    isLoading: userRegisterationIsLoading,
    isSuccess: userRegisterationIsSuccess,
    message: userRegisterationMessage
  } = useSelector((state: RootState) => state.requestLsts.addONUser);

  const {
    userDetailsData,
    isLoading: isUserDetailsLoading,
  } = useSelector((state: RootState) => state.requestLsts.fetchONUserDetails);

  const {
    isLoading: editRequestIsLoading,
  } = useSelector((state: RootState) => state.requestLsts.editONRequest);


  useEffect(() => {
    dispatch(fetchONRoles({}))
    dispatch(fetchONMemberShipPlans({ networkTypeID: "4" }))

    // Fetch user details if in edit mode
    if (isEditMode && userId) {
      dispatch(fetchONUserDetails(userId))
    }

    return () => {
      dispatch(resetFetchONRoles())
      dispatch(resetFetchONSpecialities())
      dispatch(resetFetchONUserDetails())
    }
  }, [isEditMode, userId])

  const [selectedPrimaryCountry, setSelectedPrimaryCountry] = useState("us");
  const [isPrimaryPhoneNumberValid, setIsPrimaryPhoneNumberValid] = useState(false);
  const primaryNumberRef = React.useRef<any>();
  const [secondaryNumber, setSecondaryNumber] = useState("");
  const [primaryNumber, setPrimaryNumber] = useState("");
  const [selectedSecondaryCountry, setSelectedSecondaryCountry] = useState("us");
  const [isSecondaryPhoneNumberValid, setIsSecondaryPhoneNumberValid] = useState(false);
  const secondaryNumberRef = React.useRef<any>();

  const [countriesList, setCountriesList] = useState<any[]>([]);
  const [stateList, setStateList] = useState<any[]>([]);
  const [cityList, setCityList] = useState<any[]>([]);
  const [selectedCountryId, setSelectedCountryId] = useState<number | null>(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>("");
  const [selectedStateId, setSelectedStateId] = useState<number | null>(null);

  const [licenseCountries, setLicenseCountries] = useState<any[]>([]);
  const [licenseStates, setLicenseStates] = useState<any[][]>([[]]);

  const [selectedRole, setSelectedRole] = useState<any[][]>([[]]);
  const [selectedSpecialty, setSelectedSpecialty] = useState<any[][]>([[]]);
  const [hasInteracted, setHasInteracted] = useState(false);

  // Add at the top, after licenses state
  const [practiceDetails, setPracticeDetails] = useState<PracticeDetail[]>([
    { practiceName: '', practicePosition: '', optionalPhone: '', optionalPhoneCode: '', country: '', countryName: "", state: '', stateName: "", city: '', cityName: "", address: '', address2: '', zipcode: '' }
  ]);

  // Add after practiceDetails state
  const [practiceStateLists, setPracticeStateLists] = useState<any[][]>([[]]);
  const [practiceCityLists, setPracticeCityLists] = useState<any[][]>([[]]);

  // Practice phone number states
  const [selectedPracticeCountries, setSelectedPracticeCountries] = useState<string[]>(['us']);
  const [isPracticePhoneNumbersValid, setIsPracticePhoneNumbersValid] = useState<boolean[]>([false]);
  const practicePhoneNumberRefs = React.useRef<any[]>([]);

  // Handler to add a new practice detail set
  const addPracticeDetail = () => {
    setPracticeDetails([
      ...practiceDetails,
      { practiceName: '', practicePosition: '', optionalPhone: '', optionalPhoneCode: '', country: '', countryName: "", state: '', stateName: "", city: '', cityName: "", address: '', address2: '', zipcode: '' }
    ]);
    setPracticeStateLists([...practiceStateLists, []]);
    setPracticeCityLists([...practiceCityLists, []]);
    setSelectedPracticeCountries([...selectedPracticeCountries, 'us']);
    setIsPracticePhoneNumbersValid([...isPracticePhoneNumbersValid, false]);
  };

  const storedData = StorageService.getObjStorage("super_admin_user")


  const userObj = storedData
    ? (typeof storedData === "string" ? JSON.parse(storedData) : storedData)
    : null;

  const roleName = userObj?.result?.user_data || "";
  console.log(roleName?.email, "roleName")

  // Handler to remove a practice detail set
  const removePracticeDetail = (idx: number) => {
    if (practiceDetails?.length > 1) {
      setPracticeDetails(practiceDetails.filter((_, i) => i !== idx));
      setPracticeStateLists(practiceStateLists.filter((_, i) => i !== idx));
      setPracticeCityLists(practiceCityLists.filter((_, i) => i !== idx));
      setSelectedPracticeCountries(selectedPracticeCountries.filter((_, i) => i !== idx));
      setIsPracticePhoneNumbersValid(isPracticePhoneNumbersValid.filter((_, i) => i !== idx));
      // Reset form fields for the removed row
      form.resetFields([
        `practiceName_${idx}`, `practicePosition_${idx}`,
        `optionalPhone_${idx}`,
        `country_${idx}`,
        `state_${idx}`,
        `city_${idx}`,
        `address_${idx}`,
        `address2_${idx}`,
        `address3_${idx}`,
        `zipcode_${idx}`
      ]);
    }
  };

  const handleNextWithValidation = () => {
    form
      .validateFields()
      .then(() => {
        setIsAuthModalOpen(true); // open authentication modal
      })
      .catch(() => {
        message.error('Please fill all required fields!');
      });
  };


  const handleAuthSubmit = async () => {
    if (authUsername && authPassword) {
      const params = {
        username: authUsername,
        password: authPassword,
      };

      try {
        const response = await dispatch(validateLogin(params));

        if (response?.payload?.isSuccess) {
          setIsAuthModalOpen(false);
          setAuthError('');
          toast.success("Authenticated")
          setTimeout(() => {
            setCurrentStep(prev => prev + 1);

          }, 2000)
        } else {
          setAuthError('Invalid username or password!');
        }
      } catch {
        setAuthError('Something went wrong! Try again.');
      }
    } else {
      setAuthError('Username and Password are required!');
    }
  };

  // Handler to update a field in a practice detail set
  const updatePracticeDetail = (idx: number, field: keyof PracticeDetail, value: string) => {
    setHasInteracted(true);
    const newDetails = [...practiceDetails];
    newDetails[idx][field] = value;
    setPracticeDetails(newDetails);
  };


  // Fetch countries once for license dropdowns
  useEffect(() => {
    GetCountries().then((result: any) => {
      setLicenseCountries(result);
    });
  }, []);

  const updateLicenseFields = (index: number, fields: Partial<LicenseInfo>) => {
    const newLicenses = [...licenses];
    newLicenses[index] = { ...newLicenses[index], ...fields };
    setLicenses(newLicenses);
  };


  const capitalizeFirst = (text: string) =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

  // When licenses are added/removed, sync licenseStates array
  useEffect(() => {
    setLicenseStates((prev) => {
      if (licenses?.length > prev?.length) {
        return [...prev, []];
      } else if (licenses?.length < prev?.length) {
        return prev.slice(0, licenses?.length);
      }
      return prev;
    });
  }, [licenses?.length]);

  useEffect(() => {
    GetCountries().then((result: any) => {
      setCountriesList(result);
    });
  }, []);

  // Set initial form values for preferences
  useEffect(() => {
    form.setFieldsValue({
      emailPreference: "1",
      pagerPreference: "1",
      primaryPhonePreference: "1",
      secondaryPhonePreference: "4"
    });
  }, [form]);

  // Populate form with user details when in edit mode
  useEffect(() => {
    if (isEditMode && userDetailsData && !isUserDetailsLoading && licenseCountries.length > 0) {
      populateFormWithUserDetails(userDetailsData);
    }
  }, [userDetailsData, isEditMode, isUserDetailsLoading, licenseCountries]);

  const populateFormWithUserDetails = (userData: any) => {
    // Populate basic user information
    form.setFieldsValue({
      firstName: userData.first_name || '',
      lastName: userData.last_name || '',
      displayName: userData.display_name || '',
      username: userData.username || '',
      email: userData.email || '',
      emailPreference: userData.email_pref?.toString() || '1',
      pager: userData.pager_number || '',
      pagerPreference: userData.pager_pref?.toString() || '1',
    });

    // Populate roles and specialties
    if (userData.network_roles?.length > 0) {
      const roleIds = userData.network_roles.map((role: any) => role.id);
      setSelectedRole(roleIds);
      form.setFieldsValue({ role: roleIds });

      // Fetch specialties for the selected roles
      if (roleIds.length > 0) {
        dispatch(fetchONSpecialities({ roleIDs: roleIds.join(",") }));
      }
    }

    if (userData.network_specialties?.length > 0) {
      const specialtyIds = userData.network_specialties.map((specialty: any) => specialty.id);
      setSelectedSpecialty(specialtyIds);
      form.setFieldsValue({ specialty: specialtyIds });
    }

    // Populate medical licenses
    if (userData.medical_licenses?.length > 0) {
      const licenseData = userData.medical_licenses; // Get the first array of licenses
      if (Array.isArray(licenseData)) {
        const newLicenses = licenseData.map((license: any) => {
          // Find country ID from countries list
          const countryObj = licenseCountries.find((c: any) => c.iso2 === license.country?.country_name_code);

          return {
            country: license.country?.country_name_code || '',
            countryId: countryObj?.id,
            countryName: license.country?.name || '',
            state: license.issuing_state?.state_code || '',
            stateId: undefined, // Will be set after fetching states
            stateName: license.issuing_state?.name || '',
            licenseNumber: license.license_number || '',
          };
        });
        setLicenses(newLicenses);

        // Update form values with license data
        newLicenses.forEach((license: any, index: number) => {
          form.setFieldValue(['licenses', index, 'country'], license.country);
          form.setFieldValue(['licenses', index, 'countryId'], license.countryId);
          form.setFieldValue(['licenses', index, 'countryName'], license.countryName);
          form.setFieldValue(['licenses', index, 'state'], license.state);
          form.setFieldValue(['licenses', index, 'stateId'], license.stateId);
          form.setFieldValue(['licenses', index, 'stateName'], license.stateName);
          form.setFieldValue(['licenses', index, 'licenseNumber'], license.licenseNumber);
        });

        // Fetch states for each license
        newLicenses.forEach((license: any, index: number) => {
          if (license.countryId) {
            GetState(license.countryId).then((result: any) => {
              setLicenseStates((prev) => {
                const newStates = [...prev];
                newStates[index] = result;
                return newStates;
              });

              // Find state ID after states are loaded
              const stateObj = result.find((s: any) => s.state_code === license.state);
              if (stateObj) {
                updateLicenseFields(index, { stateId: stateObj.id });
                const updatedLicense = newLicenses
                updatedLicense[index].stateId = stateObj.id
                setLicenses(updatedLicense)
                // Also update the form value
                form.setFieldValue(['licenses', index, 'stateId'], stateObj.id);
              }
            });
          }
        });
      }
    }

    // Populate contact information
    if (userData.contact_info?.length > 0) {
      const primaryContact = userData.contact_info.find((contact: any) => contact.number_status === 'primary');
      const secondaryContact = userData.contact_info.find((contact: any) => contact.number_status === 'secondary');

      if (primaryContact) {
        setPrimaryNumber(primaryContact.number);
        setSelectedPrimaryCountry('us'); // Default, will be updated based on country code
        form.setFieldsValue({
          primaryPhone: {
            number: primaryContact.number,
            code: primaryContact.country_code?.replace('+', '') || '1'
          },
          primaryPhonePreference: primaryContact.pref?.toString() || '1'
        });
      }

      if (secondaryContact) {
        setSecondaryNumber(secondaryContact.number);
        setSelectedSecondaryCountry('us'); // Default, will be updated based on country code
        form.setFieldsValue({
          secondaryPhone: {
            number: secondaryContact.number,
            code: secondaryContact.country_code?.replace('+', '') || '1'
          },
          secondaryPhonePreference: secondaryContact.pref?.toString() || '4'
        });
      }
    }

    // Populate practice sites
    if (userData.practice_sites?.length > 0) {
      const practiceData = userData.practice_sites.map((site: any) => ({
        practiceName: site.name || '', practicePosition: site.practicePosition,
        // optionalPhone: site.phone_number || '',
        // optionalPhoneCode: site.phone_number_country_code?.replace('+', '') || '',
        country: site.country?.country_name_code || '',
        countryName: site.country?.name || '',
        state: site.state?.state_code || '',
        stateName: site.state?.name || '',
        city: site.city?.name || '',
        cityName: site.city?.name || '',
        cityId: site.city?.city_code || '',
        address: site.address_one || '',
        address2: site.address_two || '',
        address3: site.address_three || '',
        zipcode: site.zipcode || ''
      }));
      setPracticeDetails(practiceData);

      // Align phone input countries with practice site countries
      // setSelectedPracticeCountries(practiceData.map((p: any) => p.country || 'us'));

      // Set known field values into the form per row
      practiceData.forEach((practice: any, idx: number) => {
        form.setFieldsValue({ [`practiceName_${idx}`]: practice.practiceName });
        form.setFieldsValue({ [`practicePosition${idx}`]: practice.practiceName });
        // form.setFieldsValue({ [`optionalPhone_${idx}`]: practice.optionalPhone });
        form.setFieldsValue({ [`address_${idx}`]: practice.address });
        form.setFieldsValue({ [`address2_${idx}`]: practice.address2 });
        form.setFieldsValue({ [`zipcode${idx}`]: practice.zipcode });
        form.setFieldsValue({ [`country_${idx}`]: practice.country || undefined });
        form.setFieldsValue({ [`state_${idx}`]: practice.state || undefined });
      });

      // Load state and city lists and set city field via setFieldsValue
      practiceData.forEach((practice: any, idx: number) => {
        const countryObj = countriesList.find((c: any) => c.iso2 === practice.country);
        if (countryObj) {
          GetState(countryObj.id).then((states: any) => {
            setPracticeStateLists(prev => {
              const newArr = [...prev];
              newArr[idx] = states;
              return newArr;
            });

            const stateObj = states.find((s: any) => s.state_code === practice.state);
            if (stateObj) {
              GetCity(countryObj.id, stateObj.id).then((cities: any) => {
                setPracticeCityLists(prev => {
                  const newArr = [...prev];
                  newArr[idx] = cities;
                  return newArr;
                });

                const cityObj = cities.find((c: any) => c.name === practice.cityName);
                if (cityObj) {
                  updatePracticeDetail(idx, 'cityId', cityObj.id);
                  updatePracticeDetail(idx, 'city', cityObj.name);
                  updatePracticeDetail(idx, 'cityName', cityObj.name);
                  form.setFieldsValue({ [`city_${idx}`]: cityObj.id });
                }
              });
            }
          });
        }
      });
    }

    // Set profile picture if exists
    if (userData.profile_pic) {
      setBase64Image(userData.profile_pic);
    }
  };

  const steps = isEditMode ? [
    {
      title: 'General Details',
      icon: <UserOutlined />,
    },
  ] : [
    {
      title: 'General Details',
      icon: <UserOutlined />,
    },

    {
      title: 'Payment and Submit',
      icon: <CreditCardOutlined />,
    },
  ];

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleCancel = () => {
    // Navigate back to the previous route
    form.resetFields();
    navigate(1);
  };

  const onFinish = (values: any) => {
    message.success('Registration completed successfully!');
  };

  // Sync licenses state with form for validation
  useEffect(() => {
    form.setFieldsValue({ licenses });
  }, [licenses, form]);


  // for check box options in multi select
  const TextWithCheckbox = (props: any) => {
    return (
      <div>
        <Checkbox
          checked={props.checked}
          style={{ margin: "0 .5rem 0 0rem" }}
        />
        {props.children}
      </div>
    );
  };

  const [base64Image, setBase64Image] = useState<any>('');

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // this reads file as base64
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };



  const renderGeneralDetails = () => (
    <div className="step-content">
      <Form
        form={form}
        layout="vertical"
        name="networkForm"
        initialValues={{
          email: roleName?.email || "",
        }}
      >
        {/* First Row: Network Name + Email */}
        <Row gutter={[24, 16]}>
          {/* Network Name */}
          <Col xs={24} sm={12}>
            <Form.Item className="info-label"
              name="networkName"
              label={<span>
                Network Name{" "}
                <Tooltip title="Enter the unique name of the network (no spaces allowed)">
                  <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 5 }} />
                </Tooltip>
              </span>}

              rules={[{ required: true, message: "Please enter network name" }]}
            >
              <Input
                placeholder="Enter network name"
                size="large"
                onChange={(e) => {
                  // Remove spaces from input
                  e.target.value = e.target.value.replace(/\s/g, '');
                  form.setFieldsValue({ networkName: e.target.value });
                }}
              />
            </Form.Item>
          </Col>

          {/* Email */}
          <Col xs={24} sm={12}>
            <Form.Item className="info-label"
              name="email"
//test commit
              label={<span>
                Email{" "}
                {/* <Tooltip title="Email">
                  <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 5 }} />
                </Tooltip> */}
              </span>}
              rules={[
                { required: true, message: "Please enter email" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input placeholder="Enter email" size="large" readOnly />
            </Form.Item>
          </Col>
        </Row>

        {/* Second Row: Site Count + User Capacity */}
        <Row gutter={[24, 16]}>
          {/* Site Count */}
          <Col xs={24} sm={12}>
            <Form.Item className="info-label"
              name="siteCount"
              label={<span>
                Site Count{" "}
                <Tooltip title="Select the number of sites in this network (1–100)">
                  <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 5 }} />
                </Tooltip>
              </span>}
              rules={[{ required: true, message: "Please select site count" }]}
            >
              <Select placeholder={capitalizeFirst("select site count")} size="large">
                {Array.from({ length: 100 }, (_, i) => i + 1).map((num) => (
                  <Select.Option key={num} value={num}>
                    {num}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {/* User Capacity */}
          <Col xs={24} sm={12}>
            <Form.Item className="info-label"
              name="userCapacity"
              label={<span>
                User Capacity{" "}
                <Tooltip title="Select the maximum number of users allowed in this network (2–100)">
                  <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 5 }} />
                </Tooltip>
              </span>}
              rules={[{ required: true, message: "Please select user capacity" }]}
            >
              <Select placeholder="Select user capacity" size="large">
                {Array.from({ length: 99 }, (_, i) => i + 2).map((num) => (
                  <Option key={num} value={num}>
                    {num}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Description */}
        <Form.Item className="info-label" name="description" label={<span>
          Description{" "}
          <Tooltip title="Enter the description">
            <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 5 }} />
          </Tooltip>
        </span>}>
          <Input.TextArea maxLength={200} placeholder="Enter description (optional)" rows={3} />
        </Form.Item>
      </Form>
    </div>
  );


  const renderPaymentStep = () => {

    const handleCreateNetwork = async (planId: string, plan: any) => {
      setLoadingPlanId(planId); // start loader for this plan
      console.log(planId, "planid");
      if (plan.is_free_trial_subscription_plan) {


        const payload = {
          network_name: form.getFieldValue("networkName").toLowerCase(),
          description: form.getFieldValue("description"),
          password: authPassword,
          site_count:form.getFieldValue("siteCount"),
          user_capacity:form.getFieldValue("userCapacity")

        };

        try {
          const response = await dispatch(createNetwork(payload));

          if (response?.payload?.isSuccess) {
            // toast.success("Network Created Succesfully");
            toast.success(response?.payload?.message);

            setCurrentStep(currentStep - 1);
            form.resetFields();

          } else {
            toast.error("Duplicate network name found");
          }
        } catch (error) {
          toast.error("Something went wrong. Please try again.");
        } finally {
          setLoadingPlanId(null); // stop loader
        }
      } else {
        const price = plan?.price;

        // Remove $ and .
        const clean = price.replace("$", "").replace(".", "");

        // Add two zeros
        const finalPrice = clean;

        const networkDetails= {
          network_name: form.getFieldValue("networkName").toLowerCase(),
          description: form.getFieldValue("description"),
          password: authPassword,
          site_count:form.getFieldValue("siteCount"),
          user_capacity:form.getFieldValue("userCapacity")

        };
        const payload = {
          amount: Number(finalPrice),
          currency: plan?.currency,
          plan_id:planId,
          product_name: 'test',//plan.name
          network_details : networkDetails

        }

        const response: any = await dispatch(makePayment(payload));
        if (response.payload.isSuccess) {
          const checkoutUrl = response.payload.result.checkout_url;
          window.open(checkoutUrl, "_blank"); // Opens in new tab
        }
        setLoadingPlanId(null);
      }
    };

    return (
      <div className="step-content">
        <Card className="pricing-card">
          <Title level={3} className="pricing-title">Choose your plan</Title>
          <Row gutter={[24, 24]} className="pricing-row">
            {
              mombershipPlanListData?.map((plan: any) => {
                return (
                  <Col xs={24} md={8}>
                    <Card className="plan-card free-plan">
                      <Title level={4}>{plan?.name}</Title>
                      <Text className="price">
                        {plan?.price}
                        <span className="price-subtext">
                          {" "}
                          {`/ ${plan?.billing_cycle}`}
                        </span>
                      </Text>
                      <Button
                        type="primary"
                        className="plan-button"
                        onClick={() => handleCreateNetwork(plan?.id, plan)}
                        // disabled={!plan.is_free_trial_subscription_plan}
                        loading={loadingPlanId === plan?.id}
                      >
                        {plan.is_free_trial_subscription_plan ? "Start Free trial" : "Get"}
                      </Button>
                      <ul className="features-list">
                        {
                          plan?.active_features?.map((feature: any) => {
                            return (
                              <li className="included">{feature?.name}</li>
                            )
                          })
                        }
                      </ul>
                    </Card>
                  </Col>
                )
              })
            }
          </Row>
        </Card>
      </div>
    );
  }

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return renderGeneralDetails();
      case 1:
        return renderPaymentStep();
      // case 2:
      //   return isEditMode ? null : renderPaymentStep();
      default:
        return null;
    }
  };

  // Show loading state when fetching user details in edit mode
  if (isEditMode && isUserDetailsLoading) {
    return (
      <div className="add-user-container">
        <Card className="registration-card">
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <div>Loading user details...</div>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="add-user-container">
      {isEditMode && (
        <div className="registration-header">
          <Title level={2} className="main-title">Edit User</Title>
          <Text className="subtitle">Update user information</Text>
        </div>
      )}

      <Card className="registration-card">
        <Steps
          current={currentStep}
          items={steps}
          className="registration-steps"
        />

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="registration-form"
          validateTrigger={['onChange', 'onBlur']}
          validateMessages={{
            required: '${label} is required',
          }}
        >
          {renderStepContent()}

          <div className="form-actions">
            <Space>
              {currentStep===0&&<Button onClick={handleCancel} type='default' size="large">
                Reset
              </Button>}
              {currentStep > 0 && (
                <Button onClick={prevStep} type='text' size="large">
                  Previous
                </Button>
              )}
              {(currentStep < steps?.length - 1 || isEditMode) && (
                <Button
                  type="primary"
                  onClick={handleNextWithValidation}
                  size="large"
                  loading={userRegisterationIsLoading || editRequestIsLoading}
                  disabled={userRegisterationIsLoading || editRequestIsLoading}
                  className='next-btn'
                >
                  {isEditMode && currentStep === steps?.length - 1 ? 'Update' : 'Next'}
                </Button>
              )}
            </Space>
          </div>
        </Form>

        <Modal
          title="Authentication Required"
          open={isAuthModalOpen}
          onCancel={() => setIsAuthModalOpen(false)}
          footer={null}
        >
          <div>
            <label>Username</label>
            <Input
              value={authUsername}
              onChange={(e) => setAuthUsername(e.target.value)}
              placeholder="Enter username"
              style={{ marginBottom: '10px' }}
            />

            <label>Password</label>
            <Input.Password
              value={authPassword}
              onChange={(e) => setAuthPassword(e.target.value)}
              placeholder="Enter password"
              style={{ marginBottom: '10px' }}
            />

            {authError && (
              <p style={{ color: 'red', marginBottom: '10px' }}>
                {authError}
              </p>
            )}
            <div style={{ textAlign: 'center', marginTop: '15px' }}>
              <Button
                type="primary"
                onClick={handleAuthSubmit}
                style={{ width: '150px' }}  // Adjust width as needed
              >
                Verify & Continue
              </Button>
            </div>

          </div>
        </Modal>
      </Card>
    </div>
  );
};
